import { render, staticRenderFns } from "./Main-comp.vue?vue&type=template&id=3180c9a8&scoped=true&"
import script from "./Main-comp.vue?vue&type=script&lang=js&"
export * from "./Main-comp.vue?vue&type=script&lang=js&"
import style0 from "./Main-comp.vue?vue&type=style&index=0&id=3180c9a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3180c9a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VScrollYReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VContainer,VMain,VScrollYReverseTransition})
